import Header from "@/components/Header";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import SEOHead from "@/components/SEOHead";

const ContactPage = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="اتصل بنا | حسن عبدالله للمقاولات والديكورات بالرياض"
        description="تواصل مع حسن عبدالله للمقاولات والديكورات بالرياض — اتصل بنا أو أرسل عبر واتساب للحصول على عرض سعر مجاني لمشروعك."
        canonical="/contact"
      />
      <Header />
      <div className="pt-20">
        <ContactSection />
      </div>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default ContactPage;
